import { createAction } from 'app-components/flux/core/actionHelpers';

export const setBumpSocketState = createAction('SET_BUMP_SOCKET_STATE');
export const receivedBumpMessage = createAction('RECEIVED_BUMP_MESSAGE');
export const sendBumpMessage = createAction('SEND_BUMP_MESSAGE');
